/* eslint-disable no-console */
import AxiosClient from './api'
import END_POINT from './constants'

export function getContactList(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.CONTACT.GET}?page=${payload.page}&limit=${payload.limit}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function updateStatusContact(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.CONTACT.GET}/${payload.id}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
